import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  FormControlLabel,
  Switch,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import InfoTooltip from '../InfoTooltip';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import {
  createAssignRefill,
  getAllRefill,
  updateAssignRefill,
  getBnbList,
  getAllCleaner,
  uploadFile,
  getAllCleaningItem,
  updateCleaningItem,
  updateAssignCleaning,
  getAllCleaningAverages,
  getCleanerSetting,
} from '../../helper/backend_helper';

const UpdateAssignRefill = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location?.state?.userData;
  const [formData, setFormData] = useState({ profileImage: null });
  const [cleaningItem, setCleaningItem] = useState(userData?.cleaningItem?._id);
  const [bnb, setBnB] = useState(userData?.bnb || []);
  const [cleaner, setCleaner] = useState(userData?.cleaner?.map((item) => item._id || item) || []);
  const [cleaning, setCleaning] = useState([]);
  const [price, setPrice] = useState(userData?.price);
  const [autoAveragePrice, setAutoAveragePrice] = useState(userData?.autoAveragePrice || false);
  const [averageRows, setAverageRows] = useState([]);
  const [cleanerSettings, setCleanerSettings] = useState({});

  const [loading, setLoading] = useState(false);
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  const [cleaners, setCleaners] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      // setUsers(usersResponse?.data?.data);
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.BnBShortName?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function fetchCleaners() {
    try {
      const cleanerResponse = await getAllCleaner();
      setCleaners(
        cleanerResponse?.data?.data?.sort((a, b) => {
          const nameA = a.name?.toLowerCase() || '';
          const nameB = b.name?.toLowerCase() || '';
          return nameA.localeCompare(nameB);
        }) || []
      );
    } catch (error) {
      console.error('Error fetching cleaners:', error);
    }
  }

  async function fetchAveragePricing() {
    try {
      const [averagesResponse, settingsResponse] = await Promise.all([
        getAllCleaningAverages(),
        getCleanerSetting(),
      ]);
      setAverageRows(averagesResponse?.data?.data || []);
      setCleanerSettings(settingsResponse?.data?.data || {});
    } catch (error) {
      console.error('Error fetching average pricing:', error);
    }
  }

  const getAveragePriceForBnb = (bnbName) => {
    const rows = averageRows.filter((item) => item.bnb === bnbName);
    if (!rows.length) return 10;
    const ignoreValue = Number(cleanerSettings?.ignoreAverageCalValue || 0);
    const cleaningRows = rows.filter((item) => Number(item.cleaningCost) > ignoreValue);
    const bedsheetRows = rows.filter((item) => Number(item.bedsheetCost) > ignoreValue);
    const avgCleaning = cleaningRows.length
      ? cleaningRows.reduce((sum, item) => sum + Number(item.cleaningCost || 0), 0) / cleaningRows.length
      : 0;
    const avgBedsheet = bedsheetRows.length
      ? bedsheetRows.reduce((sum, item) => sum + Number(item.bedsheetCost || 0), 0) / bedsheetRows.length
      : 0;
    const vatMultiplier = 1 + Number(cleanerSettings?.VAT || 0) / 100;
    return Math.max(10, (avgCleaning + avgBedsheet) * vatMultiplier * 1.25);
  };

  const applyAveragePrice = (selectedBnbs = bnb) => {
    if (!selectedBnbs.length) return;
    const recommended = Math.max(...selectedBnbs.map((bnbName) => getAveragePriceForBnb(bnbName)));
    setPrice(recommended.toFixed(2));
  };

  async function fetchRefill() {
    try {
      const usersResponse = await getAllCleaningItem();
      setCleaning(usersResponse?.data?.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
    fetchRefill();
    fetchCleaners();
    fetchAveragePricing();
  }, []);

  useEffect(() => {
    if (autoAveragePrice) applyAveragePrice();
  }, [autoAveragePrice, bnb, averageRows, cleanerSettings]);

  const handleSave = async () => {
    try {
      setLoading(true);

      if (bnb.length === 0 && cleaner.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Select at least one BnB or cleaner',
        });
        setLoading(false);
        return;
      }
      if (!cleaningItem) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Cleaning Item is required',
        });
        setLoading(false);
        return;
      }

      if (price === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Price is required',
        });
        setLoading(false);
        return;
      }

      const Categorydata = {
        bnb,
        cleaner,
        cleaningItem,
        price,
        autoAveragePrice,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await updateAssignCleaning(userData?._id, Categorydata, Categoryheaders);

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Update Assign Cleaning </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Update Assign Cleaning</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
            <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>BnB <InfoTooltip title="Properties this cleaning-item charge applies to. Leave empty to scope by cleaner instead." /></FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                multiple
                value={bnb} // This will be an array
                onChange={(e) => {
                  setBnB(e.target.value);
                  if (autoAveragePrice) applyAveragePrice(e.target.value);
                }}
                renderValue={(selected) => selected.join(', ')} // Render selected values as a comma-separated string
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    <Checkbox checked={bnb.indexOf(user.BnBShortName) > -1} />
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 3 }}>
            <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>Cleaner <InfoTooltip title="Cleaners this charge applies to. Select at least one BnB or one cleaner." /></FormLabel>
              <Select
                labelId="cleaner-multi-select-label"
                id="cleaner-multi-select"
                multiple
                value={cleaner}
                onChange={(e) => setCleaner(e.target.value)}
                renderValue={(selected) =>
                  selected
                    .map((id) => cleaners.find((item) => item._id === id)?.name || id)
                    .join(', ')
                }
              >
                {cleaners?.map((item) => (
                  <MenuItem key={item._id} value={item._id}>
                    <Checkbox checked={cleaner.indexOf(item._id) > -1} />
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
            <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>Cleaning Item <InfoTooltip title="The cleaning task or service being priced for the selected BnBs and cleaners." /></FormLabel>
              {/* <InputLabel id="demo-simple-select-label">BnB</InputLabel> */}
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={cleaningItem}
                // label="BnB"
                onChange={(e) => setCleaningItem(e.target.value)}
              >
                {cleaning?.map((user) => (
                  <MenuItem key={user._id} value={user._id}>
                    {user.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 2 }}>
            <FormLabel sx={{ mb: 1 }}>Price <InfoTooltip title="Amount paid for this cleaning item (EUR). Turn on the switch to auto-fill from the BnB average plus VAT and margin." /></FormLabel>
            <FormControlLabel
              control={
                <Switch
                  checked={autoAveragePrice}
                  onChange={(e) => {
                    setAutoAveragePrice(e.target.checked);
                    if (e.target.checked) applyAveragePrice();
                  }}
                />
              }
              label="Use average Total + VAT + 25% (min 10 EUR)"
            />
            <TextField
              label="Enter Price"
              id="outlined-size-small"
              value={price}
              disabled={autoAveragePrice}
              onChange={(e) => setPrice(e.target.value)}
            />
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>
    </>
  );
};

export default UpdateAssignRefill;
